import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import Input from '../Input';
import {
  InfoRowContainer,
  LabelColContainer,
  Label,
  InfoValue,
  InputRow,
} from '../../common/styled';
import { themeColors } from '../../../constants/themes';

const InfoRow = ({
  titleId,
  style,
  width,
  editable,
  value,
  type,
  inputStyle,
  valueStyle,
  className,
  onChange,
  children,
  inputWidth,
  title,
  bold,
  nonFixedHeight,
  labelWidth,
  disabled = false,
  error,
}) => {
  const colValue = editable ? (
    <div
      css={css`
        line-height: 1;
      `}
    >
      <Input
        id={titleId}
        value={value}
        type={type}
        onChange={onChange}
        style={inputStyle}
        width={inputWidth}
        disabled={disabled}
        css={css`
          flex-shrink: 0;
        `}
      />
      {error && (
        <div
          css={css`
            margin-top: 10px;
            color: ${themeColors.pink};
          `}
        >
          {error}
        </div>
      )}
    </div>
  ) : (
    <InfoValue style={valueStyle}>{value}</InfoValue>
  );

  return (
    <InfoRowContainer
      className={className}
      style={style}
      width={width}
      nonFixedHeight={nonFixedHeight}
      css={
        error &&
        css`
          height: 64px;
        `
      }
    >
      <LabelColContainer nonFixedHeight={nonFixedHeight} width={labelWidth}>
        <Label bold={bold} htmlFor={titleId}>
          {titleId ? <FormattedMessage id={titleId} /> : title}
        </Label>
      </LabelColContainer>
      <InputRow nonFixedHeight={nonFixedHeight}>{children || colValue}</InputRow>
    </InfoRowContainer>
  );
};

InfoRow.defaultProps = {
  editable: false,
};

InfoRow.propTypes = {
  titleId: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.string,
  editable: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  type: PropTypes.string,
  inputStyle: PropTypes.object,
  valueStyle: PropTypes.object,
  className: PropTypes.string,
  inputWidth: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.string,
  error: PropTypes.string,
  bold: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default observer(InfoRow);
